import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { Button } from "@egaranti/components";

import React from "react";
import { useTranslation } from "react-i18next";

import FieldTypeSelector from "./fieldTypeSelector";
import SortableFormField from "./sortableFormField";

const FormFieldBuilder = ({
  fields,
  addFormField,
  updateFieldOrder,
  removeField,
  form,
}) => {
  const { t } = useTranslation();

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = fields.findIndex((field) => field.id === active.id);
      const newIndex = fields.findIndex((field) => field.id === over.id);
      updateFieldOrder(oldIndex, newIndex);
    }
  };

  return (
    <div className="mb-5 flex flex-col gap-5 rounded-lg border border-gray-200 p-5">
      <div className="flex w-full items-center justify-between">
        <div>
          <h2 className="font-medium">
            {t(
              "settingsPage.productRegisterActivation.formBuilder.title",
              "Form Alanları",
            )}
          </h2>
          <p className="text-sm text-[#667085]">
            {t(
              "settingsPage.productRegisterActivation.formBuilder.desc",
              "Müşterilerinizin dolduracağı form alanlarını oluşturun",
            )}
          </p>
        </div>
        <FieldTypeSelector onSelectField={addFormField} />
      </div>

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext items={fields} strategy={verticalListSortingStrategy}>
          <div className="space-y-4">
            {fields.map((field, index) => (
              <SortableFormField
                key={field.id}
                id={field.id}
                index={index}
                field={field}
                form={form}
                onRemove={() => removeField(index)}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>

      {fields.length === 0 && (
        <div className="py-8 text-center text-gray-500">
          {t(
            "settingsPage.productRegisterActivation.formBuilder.noFields",
            'Henüz form alanı eklenmemiş. Yukarıdaki "Alan Ekle" butonunu kullanarak başlayın.',
          )}
        </div>
      )}
    </div>
  );
};

export default FormFieldBuilder;
